import { render, staticRenderFns } from "./Validate.vue?vue&type=template&id=3b9ca76a"
import script from "./Validate.vue?vue&type=script&lang=js"
export * from "./Validate.vue?vue&type=script&lang=js"
import style0 from "./Validate.vue?vue&type=style&index=0&id=3b9ca76a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports